type IAppColors = {
  dark1: string,
  dark2: string,
  dark21: string,
  mid1: string,
  mid2: string,
  mid21: string,
  mid22: string,
  light1: string,
  light11: string,
}
export const appColors: IAppColors = {
  dark1: '#050303',
  dark2: '#27061c',
  dark21: 'rgba(39,6,28,0.2)',
  mid1: '#84285b',
  mid2: '#f4c951',
  mid21: '#f3dd9e',
  mid22: 'rgba(244,201,81,0.3)',
  light1: '#efedf5',
  light11: 'rgba(239,237,245,0.2)',
}